import React, { memo } from 'react'
import {} from 'styled-components/macro'
import { Flex, Box, css } from '@alobato/flex-box'
import Text from '@alobato/text'
import { Link } from '@reach/router'
import { DashboardIcon, DoctorsIcon, SpecialitiesIcon, PlansIcon, EstablishmentsIcon, PatientsIcon, BannerIcon, ConfigIcon } from '../components/Icons'

const PartialNavLink = props => <Link {...props} getProps={({ isPartiallyCurrent }) => { return { className: isPartiallyCurrent ? `active ${props.className}` : props.className } }} />

const ExactNavLink = props => <Link {...props} getProps={({ isCurrent }) => { return { className: isCurrent ? `active ${props.className}` : props.className } }} />

const MainLayout = ({ me, children, navigate, onLogout }) => {
  return (
    <Flex flexDirection='column' position='fixed' t={0} b={0} r={0} l={0}>
      <Flex pl={3} ai='center' zIndex={2} bg='white' minHeight={64} overflow='auto' css={css`box-shadow: 0 1px 3px rgba(16, 24, 40, 0.08); border-bottom: 1px solid #e8edf4;`}>
        <Flex jc='space-between' ai='center' w='100%'>
          <Box>
            <img css={css`height: 32px;`} alt='Logo - Tria' src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAH0AAAAqCAMAAACp1aRYAAAAwFBMVEUAAAAAAP//AAAAqv+/AACZZswas+bmAE3fAEDiAE4utuTdAEXqACA+rODfEkncNFvdAEg8ruPfHErgHEc7rOE8rN/fGkg8reHhGUk/reE9rOLhF0c+rOHhFEk7ruE+reLfE0nhEkg9reE9reHgEEk7reHgF0g+rOHgF0g9reHgF0g9rOHgFkk9ruE+reHgFkhCrOA9reHfFUk9reHgFUk9reE9r+Q+sOY/sec/s+hCrODgFUnhFUniFUnkFUvmFUsMp7FVAAAANXRSTlMAAQIDBAUKChAaHCUwMTg7PEhIU1ZZWV1lZmlveH6Hj5CgorGzwcXP19vk5u/x+Pj6+/z9/iqSIZkAAARcSURBVFjDtZjrQuo6EIUntAcEdW9RUUAR5WK5ltN7ewrt+7/Vzq20aRK2cHT9EZrA50wnM6sAGABDaxvo5cRzmMeOvOBt1/O3WwADAZjw6+CnqZ+619CAilAD2qPPje+uZv0G3ibKQB0rjoJL6FhRHMy7+EtO0KG/ybI0TQ9ZtriT8B07drxL6Z4TxPHEAKOhoZvwnu9dnyy5bpbd1/FWbAfBpXSy7CRWE/5R0014yF18nck97NpiZp7131ulRyd22clUQ0eAFpmbHrXLP8Tg56HtVHQMqJQdEbqwq7bdSYagpJtwz+A47fTPfnOF/6VSXlJVUX5xRVFigZVEsUJJSPleuG5q6B+5S6l5znKfPwnBD4YVPU8iUoDhdtB7rqgL3d6jQr3xlt0RJ+7Bb5mO4Gqz92nIL+9kOXWzmVT2pbqJQ0OpXUa6/R2L4p14oqKb8ERDd/M+wIzcAz8V686oqMlqkCQSVa8bwq6qUHMb4mx50VKVeZMjD5tWUQFu/qIL3oBeQdeHW00JasIryRa+V80biY673A5fwURS6a0V2eBmn+KZu5xOPnEb0jL9r3OT1ekm9FniSZMhbYedvWsN/iJ6oKU34JMmPluYgEy4y2jd5SNN6i+hd1nV/yvTG3DNT9k749HG42YL+F+ZR0fhepzyT8hVZ8KIHfbDL0Kvvb2ATk6CuDCgDYI0Y4mOymARTcXN3q+m4kw6jrR2SDvjkLfaV+m885lb3mhUlMHKVMZ2mo7Zze7b1FqWcpJi0txKsfMi91OfXylS78pz9q90ZEBnvI6TOIrCowKHhz6RpgwCc5EJBxxXoV8e/7PoCMHAxkMFyyvFLUa07Uj0srn1C1ZxAg+1Qfd3ugHjJNB5ILsrz3c+3mhjR/Xu86AKXk83SEf1dO5jKjsrVHTWvBxqZeednUU/NlTRdzhF5uXYsaXKpDjNyqBD59Cn3IB5ccWLxIHHgrckT4tBuXSPqxPX/DIdlztznl4QzV9LTcPQY97mtlZ1CNrUV4j1XbgN9aDT04/esyeaEZviSbMR6cJ4g7rT8n1XMej09HHCLMxQ9Bl4xni87ur0Ge9rrYZZqkUMts5j6Ol8lizJua/0AINZbSeyRDpuLC6r7lGdcWxB6Ot0+jRBWpohH0RqrMSqM+GFz7PRw5Oge9pwsM+8kVJ/gk5DTN4k+pDZ0KV44vhAIanPa6JzTukxLqAPVHQ8TI8PT3Wxxyo8ds/J/Fn0YpqdkJ9Jz7PfRecm6pQUHuOb6IWBxOdaKbp0WLWkWfJNdGae/fSgFL/zdY/xTXQ+3vAD80opnvqPH6IXvmIEVy1ZJvMY5GH6R+jcV5CXshq8E5GH6Z+gl4PMRLKqHuPrdM+zVfQYLzgi/dQQr3qMTbtOT+ivBzI9IQ42GSs6LfG28RrTM9ZGrpmvSPdKA1P8kkQbzqj2ZY+RjeVJ9MnSwlq/SvTHNVlYTjE93WG5u/bVxiWvtL9SYI+x8smO9PMPynz9GhqHbnMAAAAASUVORK5CYII=" />
          </Box>
          <Box>

            <Flex jc='flex-end' ai='center'>
              <Box mr={2} width={30} height={30} overflow='hidden' borderRadius='50%' jc={'center'} border={'3px solid #eee'}>              
                {/* <img style={{width: '100%'}} src={`${BASE_API}/${me.thumbnail}?token=token%20${localStorage.getItem(AUTH_TOKEN)}`} alt='' /> */}
              </Box>
              <Box mr={3}><Text>tria@admin.com</Text></Box>
              <Box mr={3}><Text pointer underline onClick={onLogout}>Sair</Text></Box>
            </Flex>

          </Box>
        </Flex>
      </Flex>
      <Box w='100%' minHeight='calc(100vh - 60px)' overflow='auto'>
        <Flex minHeight='calc(100vh - 60px)'>
          <Box minWidth={216} css={css`background: linear-gradient(180deg, #3FAFE4 0%, #2f9bcf 100%);`}>
            
            <Box mt={3}>
              <ExactNavLink className='menulink' to='/'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><DashboardIcon /></Box><Box>Dashboard</Box>
                </Flex>
              </ExactNavLink>
              <PartialNavLink className='menulink' to='/especialidades'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><SpecialitiesIcon /></Box><Box>Especialidades</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/planos'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><PlansIcon /></Box><Box>Planos</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/estabelecimentos'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><EstablishmentsIcon /></Box><Box>Estabelecimentos</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/pacientes'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><PatientsIcon /></Box><Box>Pacientes</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/medicos'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><DoctorsIcon /></Box><Box>Médicos</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/solicitacoes'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><DashboardIcon /></Box><Box>Solicitações</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/banner'>  
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><BannerIcon /></Box><Box>Banner</Box>
                </Flex>
              </PartialNavLink>
              <PartialNavLink className='menulink' to='/configuracoes'>
                <Flex p={3} ai='center' color='white'>
                  <Box mr={2} lineHeight={1}><ConfigIcon /></Box><Box>Configurações</Box>
                </Flex>
              </PartialNavLink>
            </Box>

          </Box>
          <Box flex={1}>{children}</Box>
        </Flex>
      </Box>
    </Flex>
  )
}

export default memo(MainLayout)
